import {
  PropsWithChildren,
  useMemo,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
} from 'react';
import { InternalUser, useUnderwriters } from '.';

export type UnderwritersContextType = {
  underwriters: InternalUser[],
  setUnderwritersData: Dispatch<SetStateAction<InternalUser[]>>,
  fetchUnderwriters(): Promise<void>,
}

const defaultUnderwritersContext: UnderwritersContextType = {
  underwriters: [],
  setUnderwritersData: () => { },
  fetchUnderwriters: async () => { },
};

export const UnderwritersContext = createContext<UnderwritersContextType>(
  defaultUnderwritersContext,
);

export function useUnderwritersContext() {
  return useContext(UnderwritersContext);
}

export function UnderwritersProvider({ children }: PropsWithChildren) {
  const underwriters = useUnderwriters();

  const contextValue = useMemo(() => ({ ...underwriters }), [underwriters]);

  return (
    <UnderwritersContext.Provider value={contextValue}>
      {children}
    </UnderwritersContext.Provider>
  );
}
